export default "/images/7d7b890287dd627773e7441fe40a9e25.avif";